.page { flex: 1; overflow-y: auto; padding-bottom: 40px; background: var(--bg); }

.backRow { padding: 20px 32px 0; }

.back {
  padding: 2px;
  font-size: 13.5px;
  color: var(--blue);
  background: none;
  border: none;
  cursor: pointer;
}

:global(html.dark) .back { color: var(--navy-accent); }

/* Заголовок раздела идёт сразу под ссылкой «назад» — верхний отступ меньше */
.backRow + header { padding-top: 8px; }

.inner { padding: 0 32px; }

/* ── Заполненность ── */
.overview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 20px 48px;
  align-items: center;
  margin: 0 32px 24px;
  padding: 22px 26px;
  background: var(--hero-bg);
  border: 1px solid var(--hero-border);
  border-radius: var(--r-lg);
}

.overviewMain { display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px 12px; }

.bigValue {
  font-size: 40px;
  font-weight: 650;
  line-height: 1;
  letter-spacing: -.02em;
  color: var(--hero-strong);
  font-variant-numeric: tabular-nums;
}

.bigLabel { font-size: 14px; color: var(--hero-text); }

.overviewMain .track { flex-basis: 100%; height: 10px; margin-top: 14px; }

.facts { display: flex; gap: 36px; margin: 0; }
.facts > div { display: flex; flex-direction: column-reverse; gap: 2px; }
.facts dt { font-size: 12.5px; color: var(--hero-text); }
.facts dd { margin: 0; font-size: 22px; font-weight: 650; color: var(--hero-strong); font-variant-numeric: tabular-nums; }

.warn { color: var(--warn) !important; font-weight: 600; }

/* ── Объекты ── */
.sectionHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.sectionTitle { margin: 0; font-size: 16px; font-weight: 600; color: var(--text); }

.sortLabel { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--text2); }

.select {
  height: 34px;
  padding: 0 10px;
  font-size: 13.5px;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.tableWrap {
  overflow-x: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.table { width: 100%; font-size: 14px; border-collapse: collapse; }

.table th {
  padding: 11px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-align: left;
  white-space: nowrap;
  box-shadow: inset 0 -1px 0 var(--border);
}

.table td {
  padding: 11px 14px;
  color: var(--text);
  border-bottom: 1px solid var(--border);
}

.table tbody tr { cursor: pointer; }
.table tbody tr:last-child td { border-bottom: none; }
.table tbody tr:hover td,
.table tbody tr:focus-visible td { background: var(--table-hover); }
.table tbody tr:focus-visible { outline: 2px solid var(--blue); outline-offset: -2px; }

.name { font-weight: 500; white-space: nowrap; }
.barCol { width: 38%; min-width: 220px; }
.completion { display: flex; align-items: center; gap: 12px; }

.track {
  flex: 1;
  display: block;
  height: 8px;
  overflow: hidden;
  background: color-mix(in srgb, var(--led-open) 30%, var(--card-bg));
  border-radius: var(--r-bar);
}

.fill { display: block; height: 100%; background: var(--led-clean); border-radius: var(--r-bar); }
.pct { min-width: 56px; font-weight: 600; text-align: right; font-variant-numeric: tabular-nums; }
.num { text-align: right !important; font-variant-numeric: tabular-nums; }

@media (max-width: 1023px) {
  .overview { grid-template-columns: 1fr; }
}

@media (max-width: 699px) {
  .backRow { padding: 14px 16px 0; }
  .inner { padding: 0 16px; }
  .overview { margin: 0 16px 20px; padding: 18px 16px; }
  .facts { gap: 24px; }
}
